import { RespuestaLecturaError } from '../Mensajes';
import { llamadaAPI_GET, llamadaAPI_POST } from '../SQL';
import { TratamientoDeParametroParaURI } from '../Varios';

export const function_STK_ART_Merma_Listar = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_STK_ART_Merma_Listar"

    try {        
        const resulData = await llamadaAPI_GET("STK_ART_Merma/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" + 
            FechaDesde + "/" + 
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_STK_ART_Merma_Generar_JSON = async (CodigoArticulo, CodigoPresentacion, CodigoTamano, CodigoUnidadMedida, CodigoUbicacion,
    Cantidad, CodigoCompania, Observaciones, Fecha) => {
    const NombreFuncion = "function_STK_ART_Merma_Generar_JSON";

    try {
        const JSON = {
            CodigoArticulo: CodigoArticulo,
            CodigoCompania: CodigoCompania,
            CodigoPresentacion: CodigoPresentacion,
            CodigoTamano: CodigoTamano,
            CodigoUnidadMedida: CodigoUnidadMedida,
            CodigoUbicacion: CodigoUbicacion,
            Cantidad: Cantidad,
            Observaciones: Observaciones,
            Fecha: Fecha,
            Terminal: localStorage.getItem("CodigoCompania")
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_STK_ART_MermasMultiples_Generar_JSON = (operaciones, Observaciones, Fecha) => {
    const NombreFuncion = "function_STK_ART_MermasMultiples_Generar_JSON";

    try {
        const operacionesCompleta = operaciones.map((item) => ({
            CodigoArticulo: item.CodigoArticulo,
            CodigoCompania: item.CodigoCompania,
            CodigoEmpresa: item.CodigoEmpresa,
            CodigoPlanta: item.CodigoPlanta,
            CodigoPresentacion: item.CodigoPresentacion,
            CodigoTamano: item.CodigoTamano,
            CodigoUnidadMedida: item.CodigoUnidadMedida,
            CodigoUbicacion: item.CodigoUbicacion,
            Cantidad: item.Cantidad,
            Observaciones: Observaciones,
            Fecha: Fecha,
            Terminal: localStorage.getItem("Terminal"), 
        }));

        return operacionesCompleta;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_STK_ART_Merma_Insertar = async (Operacion) => {
    const NombreFuncion = "function_STK_ART_Merma_Insertar";

    try {
        const mermaResult = await llamadaAPI_POST("STK_ART_Merma/InsertarCompleto/",
            Operacion);
        return mermaResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_STK_ART_Merma_InsertarMultiples = async (Operaciones) => {
    const NombreFuncion = "function_STK_ART_Merma_InsertarMultiples";

    try {
        const mermaResult = await llamadaAPI_POST("STK_ART_Merma/InsertarMultiples/" +
            localStorage.getItem("CodigoCompania"),
            Operaciones);
        return mermaResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};